import * as React from "react";
import { createRoot } from "react-dom/client";

import App from "./components/App";
import ErrorContextProvider from "./store/error-context-api";
import ThemeContextProvider from "./store/theme-context-api";
import UserContextProvider from "./store/user-contex-api";
import ToasterContextProvider from "./store/toaster-context-api";
import DrawerContextProvider from "./store/drawer-navigator-context-api";

import "./taskpane.css";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

const AppProvider = () => (
  <ThemeContextProvider>
    <ToasterContextProvider>
      <UserContextProvider>
        <ErrorContextProvider>
          <DrawerContextProvider>
            <App />
          </DrawerContextProvider>
        </ErrorContextProvider>
      </UserContextProvider>
    </ToasterContextProvider>
  </ThemeContextProvider>
);

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(<AppProvider />);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
